import { ProductPrice, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import React from 'react';
import { IActionContext, HtmlHeadInclude } from '@msdyn365-commerce/core';
import { getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { createCanonicalUrl } from '../../../common/utilities/createCanonicalUrl';

const getProductUrl = (simpleProductData: SimpleProduct, context: IActionContext) => {
    const productUrl = getProductUrlSync(simpleProductData, context);
    const canonicalDomain = context.requestContext.canonicalDomain;
    if (productUrl && canonicalDomain) {
        return `https://${canonicalDomain}${productUrl}`.toLocaleLowerCase();
    }

    return undefined;
};

const JsonLinkingData = ({
    productInfo,
    actionContext,
    productPrice
}: {
    productInfo?: SimpleProduct;
    actionContext: IActionContext;
    productPrice?: ProductPrice;
}) => {
    const brand = productInfo?.ExtensionProperties?.find(ep => ep.Key === 'Brand')?.Value?.StringValue;
    const mfrCode = productInfo?.ExtensionProperties?.find(ep => ep.Key === 'MfrCode')?.Value?.StringValue;
    const request = actionContext.requestContext;

    if (!productInfo) {
        return null;
    }

    const canonicalUrl =
        createCanonicalUrl(actionContext, [productInfo.Name ?? ''], `${productInfo.RecordId}.p`) ||
        getProductUrl(productInfo, actionContext);
    const ld = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        '@id': canonicalUrl,
        name: productInfo.Name || '',
        image: productInfo.PrimaryImageUrl && [productInfo.PrimaryImageUrl],
        description: productInfo.Description || undefined,
        sku: productInfo.ItemId,
        mpn: mfrCode,
        brand:
            (brand && {
                '@type': 'Brand',
                name: brand
            }) ||
            undefined,
        offers: {
            '@type': 'Offer',
            url: request.canonicalUrl || request.url.requestUrl,
            priceCurrency: request.channel?.Currency,
            price: productPrice?.CustomerContextualPrice ?? productInfo.Price
        }
    };

    return (
        <HtmlHeadInclude>
            {/* tslint:disable-next-line: react-no-dangerous-html */}
            <script
                data-load-point='headEnd'
                type='application/ld+json'
                id='hei-buybox__ld-json'
                dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
            />
        </HtmlHeadInclude>
    );
};

export { JsonLinkingData };
